import {useState} from "react"
import CreateListGroup from "./CreateListGroup";
import MoreInfoBox from "./MoreInfo";
import SearchItem from "./SearchItem";

export default function XfinityDevices({jsonData, index}){
    const [displayListBlock, updateListBlock] = useState({
      "current":"xfinStreaming",
      "xfinStreaming":"flex",
      "xfinMobile":"none",
      "search": 'none'
    }) 
    const [MoreInfoBoxData, setMoreInfoBoxData] = useState({});
    const [MoreInfoBoxDisplay, setMoreInfoBoxDisplay] = useState("none");
    const setMoreInfoData = (data) => {
      setMoreInfoBoxData(data);
      setMoreInfoBoxDisplay("flex");
    }
    const updateDisplayListBlock = (listBlock) => {
      updateListBlock(displayListBlock => ({...displayListBlock, [displayListBlock["current"]]:"none"}));
      updateListBlock(displayListBlock => ({...displayListBlock, "current":listBlock}));
      updateListBlock(displayListBlock => ({...displayListBlock, [listBlock]:"flex"}));
    }
    
    return (
      <div id='xfinity-deviceList-container'>
      <MoreInfoBox data={MoreInfoBoxData} display={MoreInfoBoxDisplay} setDisplay={setMoreInfoBoxDisplay}/>
      <nav className='xfinity-deviceList-container-nav'>
        <ul id="xfinity-deviceList-NavItems">
          <li>
              <button 
                      className="xfinity-deviceList-NavItems-button"
                      style={{backgroundColor: displayListBlock["xfinStreaming"] === "flex" ? "#003366" : "#FFCC33"}} 
                      onClick={()=>{updateDisplayListBlock("xfinStreaming")}}>
                  <span style={{color: displayListBlock["xfinStreaming"] === "flex" ? "white" : "black"}}>Streaming Devices</span>
              </button>
              {displayListBlock["xfinStreaming"] === "flex" && <span className='xfinity-deviceList-NavItems-activated'></span>}
          </li>
          <li>
              <button 
                      className="xfinity-deviceList-NavItems-button"
                      style={{backgroundColor: displayListBlock["xfinMobile"] === "flex" ? "#003366" : "#FFCC33"}} 
                      onClick={()=>{updateDisplayListBlock("xfinMobile")}}>
                  <span style={{color: displayListBlock["xfinMobile"] === "flex" ? "white" : "black"}}>Mobile Devices</span>
              </button>
              {displayListBlock["xfinMobile"] === "flex" && <span className='xfinity-deviceList-NavItems-activated'></span>}
          </li>
          <li>
              <button
                      className="xfinity-deviceList-NavItems-button"
                      style={{backgroundColor: displayListBlock["search"] === "flex" ? "#003366" : "#FFCC33"}} 
                      onClick={()=>{updateDisplayListBlock("search")}}>
                      <span style={{color: displayListBlock["search"] === "flex" ? "white" : "black"}}>Search for Device</span>
              </button>
              {displayListBlock["search"] === "flex" && <span className='xfinity-deviceList-NavItems-activated'></span>}
          </li>
        </ul>
      </nav>
      <div id="xfinity-deviceList-listsContainer">
        <div id="xfinStreaming" className='xfinity-deviceList-listsInnerContainer' style={{display:displayListBlock["xfinStreaming"], }}>
          <CreateListGroup type="streaming" data={jsonData["Xfinity Streaming Devices"]} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="xfinMobile" className='xfinity-deviceList-listsInnerContainer' style={{display:displayListBlock["xfinMobile"]}}>
          <CreateListGroup data={jsonData["Xfinity Mobile Devices"]} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="search" className='xfinity-deviceList-listsInnerContainer-search' style={{display:displayListBlock['search']}}>
          <SearchItem data={index} moreInfoSetData={setMoreInfoData}/>
        </div>
      </div>
    </div>
    )
  }